import { HttpResponse } from '@angular/common/http';
import { RequestOptions } from '@app/types';
import { Request } from '@backend/requests/request';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

class TemporaryInvestmentPlanRiskProfileRequest extends Request<never, string> {
  constructor(options?: RequestOptions<never>) {
    super({
      ...options,
      path: `${options?.version ?? '/v2'}/investment_plans/${
        options?.pathParams?.investmentPlanIdentifier
      }/profile/risk`
    });
  }

  public execute(): Observable<string> {
    return super.execute().pipe(map((response: HttpResponse<string>) => response.body));
  }
}

export function getTemporaryInvestmentPlanRiskProfile(
  options?: RequestOptions<never>
): TemporaryInvestmentPlanRiskProfileRequest {
  return new TemporaryInvestmentPlanRiskProfileRequest(options);
}
